import request from './adminRequest'

export const videoApi = {
  listVideo (params) {
    return request.get('/videos', { params: params })
  },
  getVideo (videoId) {
    return request.get('/videos/' + videoId)
  },
  saveVideo (data) {
    return request.post('/videos/', data)
  },
  updateVideo (videoId, data) {
    return request.put('/videos/' + videoId, data)
  },
  deleteVideo (videoId) {
    return request.delete('/videos/' + videoId)
  },
}
export default videoApi
